<template>
  <v-container wrap class="text-center">
    <circles-loader></circles-loader>
    <div v-if="error">
      <h2>{{ $t('message.error_generic') }}</h2>
      <v-btn @click="goBack()">
        {{ $t('message.back') }}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import Api from "@/services/Api";
import {Environment} from "@/services/Environment";

export default {
  data() {
    return {
      transactionId: this.$route.params.transactionId,
      sessionId: this.$route.params.sessionId,
      stripePublishableKey: null,
      stripeAccountId: this.$store.state.stripeAccountId,
      error: false
    };
  },
  components: {
    CirclesLoader
  },
  created() {
    if (this.$route.query.altStripeAccount)
      this.stripeAccountId = this.$route.query.altStripeAccount;
    //Get transaction, if not cancelled, proceed
    if (this.transactionId) {
      Api()
        .get("admins/academy/" + this.$store.state.managedAcademy + '/payments/transactions/' + this.transactionId)
        .then(response => {
          this.transaction = response.data.transaction;
          if (!this.transaction.cancelled) {
            if (this.transaction.paymentsModule == "infinicept") {
              const postData = { routeFrom: 'bulk', transactionId: this.transactionId };
              this.navigateTo({
                name: "inifnicept-checkout",
                params: { transactionData: postData, transactionId: this.transactionId }
              });
              return;
            }
            //Always init a new session 
            this.initNewSession();
          } else {
            this.error = true;
          }
        })
        .catch(e => { console.log(e) });
    } else if (this.sessionId) {
      //console.log('Loading with with session: ', this.sessionId);
      this.checkout(this.sessionId);
    }
  },
  watch: {},
  methods: {
    checkout(sessionId) {
      this.stripePublishableKey = Environment.get("VUE_APP_STRIPE_PUBLISHABLE_KEY");
      if (this.stripeAccountId) {
        /*eslint-disable no-undef*/
        var stripe = Stripe(this.stripePublishableKey, {
          stripeAccount: this.stripeAccountId
        });
        /*eslint-disable no-undef*/
        stripe.redirectToCheckout({
          sessionId: sessionId
        });
      } else {
        Api()
          .get("admins/academy/" + this.$store.state.selectedAcademy)
          .then((response) => {
            this.academy = response.data;
            Api()
              .get(
                "admins/academy/" +
                this.$store.state.managedAcademy +
                "/is_connected/stripe"
              )
              .then((response) => {
                console.log('No Stripe Account Id!')
                this.isConnected = response.data.stripeConnected;
                if (this.isConnected) {
                  if (!this.stripeAccountId) {
                    this.$store.dispatch("setStripeAccountId", response.data.id);
                    location.reload();
                  }
                }
                if (!this.stripeAccountId) {
                  this.showAlert("error", "Oops!", "Contact BJJLINK, there is a problem with our payments connector.");
                }
              });
          });
      }
    },
    initNewSession() {
      //make an initi in payment p2 just like we do with _User
      Api()
        .patch("payments/academy/" + this.$store.state.managedAcademy + "/transactions/" + this.transactionId + "/checkout/init")
        .then((response) => {
          this.sessionId = response.data.session ? response.data.session.id : null;
          if (this.sessionId) {
            this.checkout(this.sessionId);
          } else {
            this.showAlert("error", this.$t("message.error_generic"));
          }
        });
    }
  }
};
</script>

<style scoped></style>
